<template>
    <div>
        <div class="question-title">
            {{ survey.question }}
        </div>
        <textarea class="nps-text-input" v-model="inputValue" @keyup="setValue" placeholder="Saisissez ici la réponse..."></textarea>
    </div>
</template>

<script>
    export default {
        name: 'Survey',
        props: ['survey'],
        data() {
            return {
                inputValue: null,
                questionId: 18,
            };
        },
        methods: {
            setValue() {
                this.$emit('valueChanged', this.inputValue, this.survey.id, 'text');
            }
        },
        created() {

        },
        mounted() {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .question-title {
        font-size: 40px;
        display: block;
    }


    .nps-text-input {
        appearance: none;
        border: none;
        width: 650px;
        height: 300px;
        margin-top: 30px;
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(178, 178, 178, 0.50);
        border-radius: 8px;
        outline: none;
        resize: none;
        padding: 30px;
        font-size: 16px;
    }

</style>
